import React, { useState } from "react";
import RichText from "components/rich-text";
import { Card, Accordion } from "react-bootstrap";
import * as styles from "./style.mod.scss";
import { ChevronDown } from "react-bootstrap-icons";
import Image from "components/image";
import locale from "locales";
import Link from "components/link";

const PDPCampaign = ({ content, pdpSettings }) => {
  const [open, setOpen] = useState(1);
  const campaignImage = content?.campaignImage;
  const campaignImageMobile = content?.mobileCampaignImage;


  const hasPDPSnippet = campaignImage;
  const image = hasPDPSnippet ? campaignImage : pdpSettings?.snippet;
  if (!image || content?.accordion === null) return <></>;


  return (
    <div className={styles.accordionContainer}>
      <Link to={pdpSettings?.link}>
        <div className={styles.campaignImg}>
          {image && <Image className={campaignImage ? styles.pdpSnippetDesktop : styles.pdpSettingSnippet} image={image} alt={locale.altText.campaignImage} />}
          {campaignImageMobile && <Image image={campaignImageMobile} className={campaignImageMobile ? styles.pdpSnippetMobile : styles.pdpSettingSnippetMob} alt={locale?.altText?.campaignImage} />}
        </div>
      </Link>

      {content?.accordion &&
        <>
          <Accordion.Toggle
            as={Card.Header}
            eventKey={open}
            className={styles.toggleHeader}
            onClick={() => setOpen(open === 1 ? null : 1)}
          >
            <div className={styles.accrodionTitleIcon}>
              <p className={styles.accordionTitle}>{content?.accordion?.title}</p>
              <span className={`${styles.accordionIcon} ${1 !== open ? styles.accordionIconOpen : ""}`}>
                <ChevronDown />
              </span>
            </div>

          </Accordion.Toggle>
          <Accordion.Collapse eventKey={open}>
            <Card.Body className={styles.accordionBody}>
              <RichText
                className={styles.description}
                blocks={content?.accordion?.content}
              />
            </Card.Body>
          </Accordion.Collapse></>
      }
    </div>
  );
};

export default PDPCampaign;